function calloutToggle(elem, open = false) {
    if (open) {
        if (!elem.closest(".callout").hasClass("hidden")) {
            return;
        }
    }

    elem.toggleClass("hidden");
    elem.closest(".callout").toggleClass("hidden");
    let span = $(this).find("span");
    span.toggleClass("carousel-control-prev-icon");
    span.toggleClass("carousel-control-next-icon");
}

$(document).ready(function() {
    if(localStorage.getItem('newsletterClosed') != "true") {
        setTimeout(function() { 
            if (screen.width > 767 && window.innerHeight > 935) {
                calloutToggle($(".callout-open, .callout-close"), true);
            }
        }, 6000);
    }

    $(".callout-open").on("click", function() {
        calloutToggle($(this));
    });
    $(".callout-close").on("click", function() {
        calloutToggle($(this));
        localStorage.setItem('newsletterClosed', "true")
    });
});
